<script setup lang="ts">
const { locale } = useI18n();

useHead({
  titleTemplate: (title) => (title ? `${title} - Clicksign` : 'Clicksign'),
  htmlAttrs: {
    lang: locale.value,
  },
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
